/* eslint-disable */
import React, { useEffect, useState } from 'react';
import RecursiveAccordion from '../Components/RecursiveAccordian/recursiveAccordion';
import {
  getCommercialData,
  editCommercialData,
  addCommercialData,
  deleteCommercialData,
} from '../../../../Api/request/commercialWorkflow';
import UseAxios from '../../../../Api/http/http';
import HeaderSection from '../Components/Header/header';
import CommercialDialog from '../Components/Dialogs/AddDialog/addDialog';
import EditDialog from '../Components/Dialogs/EditDialog/editDialog';
import { dealRoleList } from '../../../../Api/request/roleMaster';
import PropTypes from 'prop-types';
import { getDealDetails } from '../../../../Api/request/dealDetails';
const parameters = ['Deal Value','Margin','Deal Type'];

const App = ({ alignment , hasAccess}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [data, setData] = useState([]);
  const [selectedNode, setSelectedNode] = useState({});
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [approverOptions, setApproverOptions] = useState([]);
  const [dealTypes,setDealTypes] = useState([])

  const handleEdit = (node) => {
    setSelectedNode(node);
    setIsEditDialogOpen(true);
  };

  const updateDetails = (id, newDetails, parentNode) => {
    const replaceDetails = (node) => {
      if (node.details) {
        node.details = newDetails;
      }
      for (const key in node) {
        if (typeof node[key] === 'object' && node[key] !== null) {
          replaceDetails(node[key]);
        }
      }
    };

    replaceDetails(parentNode);

    const editData = async () => {
      try {
        const res = await UseAxios(editCommercialData(parentNode));
        if (res.data.status === 200) {
          parentNode = res.data.response;
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    editData();
  };

  const handlePopoverOpen = (event) => {
    if (event) {
      setAnchorEl(event.currentTarget);
      setIsAddDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setIsAddDialogOpen(false);
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const res = await UseAxios(getCommercialData(token));
        if (res.data.status === 200) {
          setData(res.data.response);
        } else {
          setData([]);
        }
      } catch (err) {
        setData([]);
        console.error('Error fetching data:', err);
      }
    };

    const fetchApprovers = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const res = await UseAxios(dealRoleList(token));
        const data = res.data.roleDetails;
        setApproverOptions(data);
      } catch (err) {
        console.error('Error fetching approver options:', err);
      }
    };

    const fetchDealDetails = async () => {
      try {
        const res = await UseAxios(getDealDetails(1));
        const data = res.data.dealType;
        setDealTypes(data)
      } catch (err) {
        console.error('Error fetching approver options:', err);
      }
    };

    fetchDealDetails()
    
    fetchApprovers();

    fetchData();
  }, []);

  const addData = (newDetails) => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const res = await UseAxios(addCommercialData(newDetails, token));
        if (res.data.status === 200) {
          const getData = await UseAxios(getCommercialData());
          setData(getData.data.response);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  };

  const handleDelete = (node) => {
    const deleteData = async () => {
      try {
        const res = await UseAxios(deleteCommercialData(node));
        if (res.data.status === 200) {
          const getData = await UseAxios(getCommercialData());
          setData(getData.data.response);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    deleteData();
  };

  const editData = (newDetails) => {
    const fetchData = async () => {
      try {
        const res = await UseAxios(editCommercialData(newDetails));
        if (res.data.status === 200) {
          const getData = await UseAxios(getCommercialData());
          setData(getData.data.response);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  };

  return (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
      <HeaderSection handlePopoverOpen={handlePopoverOpen} hasAccess={hasAccess}/>
      {data && data.length > 0 ? (
        data.map((node) => (
          <RecursiveAccordion
            key={node.id}
            node={node}
            approverOptions={approverOptions}
            updateDetails={(id, newDetails) =>
              updateDetails(id, newDetails, node)
            }
            handleEdit={() => handleEdit(node)}
            handleDelete={() => handleDelete(node)}
            hasAccess={hasAccess}
          />
        ))
      ) : (
        <p>No data available</p>
      )}
      {isAddDialogOpen && (
        <CommercialDialog
          isOpen={isAddDialogOpen}
          onClose={handleDialogClose}
          anchorEl={anchorEl}
          addData={addData}
          parameters={parameters}
          alignment={alignment}
          dealTypes={dealTypes}
        />
      )}
      <EditDialog
        isEditDialogOpen={isEditDialogOpen}
        setIsEditDialogOpen={setIsEditDialogOpen}
        selectedNode={selectedNode}
        setSelectedNode={setSelectedNode}
        editFromDialog={editData}
        alignment={alignment}
        dealTypes={dealTypes}
      />
    </div>
  );
};

App.propTypes = {
alignment: PropTypes.string.isRequired,
hasAccess: PropTypes.bool.isRequired,
};
export default App;
